/**
 * Component: M24 Customer Cards
 *
 */
'use strict';

import {FilterHelper} from '../filter-helper.js';

export class CustomerCards {
	constructor() {
		this.selectors = {
			component: $('.c-v4-m24-customer-cards'),
			main: $('.c-v4-m24-customer-cards--main')
		};

		this.helper = new FilterHelper;
	}

	/**
	 * Init
	 *
	 */
	init() {
		if (!this.selectors.component.length) return;

		this.helper.init_config({
			action: 'sysdig_v4_filter__customer_cards',
			add_chip_on_active: true,
			component_id: this.selectors.component.attr('id'),
			items_per_page: 9,
			items_per_row: this.selectors.main.attr('data-per-row') || 3,
			paged: 1,
			post_types: ['sd-case-studies'],
			remove_chip_on_deactivate: true,
			search_term: '',
			terms: JSON.parse( this.selectors.main.attr('data-terms') ) || {},
			url: this.selectors.main.attr('data-url'),
			order_by: 'title',
		});

		this.helper.init_target({
			target_container: this.selectors.main,
			top: this.selectors.main,
		});

		this.helper.init();
	}
}
